import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function GlossaryScreen({ activeItem }) {
  if (!activeItem) return null;

  return (
    <div className="w-full max-w-4xl mx-auto mt-8 md:mt-12 p-1 rounded-2xl bg-gradient-to-b from-gray-400 to-gray-600 shadow-[0_10px_25px_rgba(0,0,0,0.5)]">
      {/* Screen Bezel */}
      <div className="bg-gray-900 rounded-xl p-4 md:p-8 shadow-[inset_0_5px_15px_rgba(0,0,0,0.8)] border border-gray-700">
        
        {/* Screen Content Area (Digital look) */}
        <div className="relative min-h-[150px] md:min-h-[180px] flex flex-col">
          
          {/* Header */}
          <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-700/50">
            <SafeIcon name="Info" className="text-cyan-400 text-xl" />
            <h3 className="text-cyan-400 font-mono text-lg md:text-xl tracking-wider uppercase">
              {activeItem.title}
            </h3>
            <span className="ml-auto text-gray-500 font-mono text-xs">REF: {activeItem.id.toUpperCase()}</span>
          </div>

          {/* Text Content with Animation */}
          <div className="flex-grow overflow-y-auto pr-2 custom-scrollbar">
            <AnimatePresence mode="wait">
              <motion.p
                key={activeItem.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="text-gray-300 font-mono text-sm md:text-base leading-relaxed"
              >
                {activeItem.text}
              </motion.p>
            </AnimatePresence>
          </div>
          
          {/* Scanline effect overlay */}
          <div className="absolute inset-0 pointer-events-none rounded bg-[linear-gradient(rgba(255,255,255,0),rgba(255,255,255,0)_50%,rgba(0,0,0,0.1)_50%,rgba(0,0,0,0.1))] bg-[length:100%_4px] opacity-20" />
        </div>
      </div>
    </div>
  );
}